import api from '@/api'


function getDisplay() {
  if (window.innerWidth < 600) {
    return "xs"
  } else if (window.innerWidth >= 600 && window.innerWidth < 960) {
    return "sm"
  } else if (window.innerWidth >= 960 && window.innerWidth < 1264) {
    return "md"
  } else if (window.innerWidth >= 1264 && window.innerWidth < 1904) {
    return "lg"
  } else {
    return "xl"
  }
}

export default {
  namespaced: true,
  state: {
    display: getDisplay(),
    footer: {},
    terms: "",
    terms_business: "",
    privacy: "",
    login_description: "",
    register_description: "",
    business_register_description: "",
    support_description: "",
    stripe_key: '',
    support_options: [],
    tutorials: {},
    about: {},
    links_whitelist: [],
    support_thanks_video: {},
    edit_claim_description: '',
    project_report_categories: {},
    newsletter: '',
    project_requirements: {},
    footer_banner: {},
    header: {},
    info_box: {},
    affiliate_disclaimer: '',
    cookies_policy: '',
    affiliate_notification: '',
  },
  getters: {
    supportOptions(state) {
      return state.support_options.sort((a, b) => {
        if (a > b) {
          return 1
        }
        if (a < b) {
          return -1
        }
        return 0
      })
    }
  },
  mutations: {
    resized: function (state) {
      state.display = getDisplay()
    }
  },
  actions: {
    async load(context) {
      let application = await api({
        method: "GET",
        url: "/application"
      })
      context.state.footer = application.footer
      context.state.terms = application.terms
      context.state.terms_business = application.terms_business
      context.state.login_description = application.login_description
      context.state.register_description = application.register_description
      context.state.support_description = application.support_description
      context.state.edit_claim_description = application.edit_claim_description
      context.state.tutorials = application.tutorials
      context.state.about = application.about
      context.state.links_whitelist = application.links_whitelist
      context.state.support_options = application.support_options
      context.state.stripe_key = application.stripe_key
      context.state.support_thanks_video = application.support_thanks_video
      context.state.project_report_categories = application.project_report_categories
      context.state.project_agreements = application.project_agreements
      context.state.privacy = application.privacy
      context.state.newsletter = application.newsletter
      context.state.project_requirements = application.project_requirements
      context.state.footer_banner = application.footer_banner
      context.state.header = application.header
      context.state.info_box = application.info_box;
      context.state.business_register_description = application.business_register_description

      context.state.affiliate_disclaimer = application.affiliate_disclaimer;
      context.state.cookies_policy = application.cookies_policy;
      context.state.affiliate_notification = application.affiliate_notification;
    }
  }
}